export const isNullOrEmpty = dataObjValue => {
	return !dataObjValue || (Array.isArray(dataObjValue) && !dataObjValue.length) || (typeof dataObjValue === "string" && !dataObjValue.trim().length);
};

export const SCRAPING_PAGE_TYPE = {
	Seia: 0,
	Bienes: 1,
	PJUD: 2,
	SII: 3,
	BoletinMineria: 4,
	BackgroundProcess: 5,
	SoyChile: 6
};

export const SCRAPING_PAGE_TYPE_NAME = {
	0: "SEIA",
	1: "Bienes",
	2: "PJUD",
	3: "SII",
	4: "Boletin Mineria",
	5: "BackgroundProcess",
	6: "Soy Chile"
	
};

export const unMountedComponentState = { };
export const socketQueue = {};

//https://zeus.sii.cl/avalu_cgi/br/brc801.sh
export const REGIONS = {
	"15": {
		name: "REGION DE ARICA Y PARINACOTA",
		cities: [
			{ "01101": "ARICA"}, { "01106": "CAMARONES"}, { "01302": "GENERAL LAGOS"}, { "01301": "PUTRE"}, 
		]
	},
	"01": {
		name: "REGION DE TARAPACA",
		cities: [
			{ "01211": "ALTO HOSPICIO"}, { "01208": "CAMINA"}, { "01210": "COLCHANE"}, { "01206": "HUARA"},
			{ "01201": "IQUIQUE"}, { "01203": "PICA"}, { "01204": "POZO ALMONTE"}
		]
	},
	"02": {
		name: "REGION DE ANTOFAGASTA",
		cities: [
			{ "02201": "ANTOFAGASTA"}, { "02301": "CALAMA"}, { "02103": "MARIA ELENA"}, { "02203": "MEJILLONES"},
			{ "02302": "OLLAGUE"}, { "02303": "SAN PEDRO ATACAMA"}, { "02206": "SIERRA GORDA"}, { "02202": "TALTAL"},
			{ "02101": "TOCOPILLA"}
		]
	},
	"03": {
		name: "REGION DE ATACAMA",
		cities: [
			{ "03304": "ALTO DEL CARMEN" }, { "03202": "CALDERA" }, { "03101": "CHANARAL" }, { "03201": "COPIAPO" },
			{ "03102": "DIEGO DE ALMAGRO" }, { "03302": "FREIRINA" }, { "03303": "HUASCO" }, { "03203": "TIERRA AMARILLA" },
			{ "03301": "VALLENAR"}
		]
	},
	"04": {
		name: "REGION DE COQUIMBO",
		cities: [
			{ "04104": "ANDACOLLO" }, { "04304": "CANELA" }, { "04205": "COMBARBALA" }, { "04103": "COQUIMBO" },
			{ "04301": "ILLAPEL"}, { "04102": "LA HIGUERA" }, { "04101": "LA SERENA" }, { "04303": "LOS VILOS" }, 
			{ "04203": "MONTE PATRIA" }, { "04201": "OVALLE" }, { "04106": "PAIHUANO" }, { "04204": "PUNITAQUI" }, 
			{ "04206": "RIO HURTADO" }, { "04302": "SALAMANCA" }, { "04105": "VICUNA" }
		]
	},
	"05": {
		name: "REGION DE VALPARAISO",
		cities: [  
			{ "05406": "ALGARROBO" }, { "05203": "CABILDO" }, { "05702": "CALLE LARGA" }, { "05403": "CARTAGENA" },
			{ "05305": "CASABLANCA" }, { "05603": "CATEMU" }, { "05309": "CON - CON" }, { "05405": "EL QUISCO" }, 
			{ "05404": "EL TABO" }, { "05503": "HIJUELAS" }, { "05101": "ISLA DE PASCUA" }, { "05308": "JUAN FERNANDEZ" },
			{ "05504": "LA CALERA" }, { "05505": "LA CRUZ" }, { "05201": "LA LIGUA" }, { "05506": "LIMACHE" },
			{ "05606": "LLAY LLAY" }, { "05701": "LOS ANDES" }, { "05502": "NOGALES" }, { "05507": "OLMUE" },
			{ "05602": "PANQUEHUE" }, { "05205": "PAPUDO" }, { "05202": "PETORCA" }, { "05307": "PUCHUNCAVI" },
			{ "05604": "PUTAENDO" }, { "05501": "QUILLOTA" }, { "05304": "QUILPUE" }, { "05306": "QUINTERO" }, { "05704": "RINCONADA" },
			{ "05401": "SAN ANTONIO" }, { "05703": "SAN ESTEBAN" }, { "05601": "SAN FELIPE" }, { "05605": "SANTA MARIA" },
			{ "05402": "SANTO DOMINGO" }, { "05301": "VALPARAISO" }, { "05303": "VILLA ALEMANA" }, { "05302": "VINA DEL MAR" }, { "05204": "ZAPALLAR" }
		]
	},
	"13": {
		name: "REGION METROPOLITANA DE SANTIAGO",
		cities: [
			{ "14605": "ALHUE" }, { "16403": "BUIN" }, { "16402": "CALERA DE TANGO"}, { "14166": "CERRILLOS" }, { "14156": "CERRO NAVIA" }, 
			{ "14201": "COLINA" }, { "14127": "CONCHALI" }, { "14603": "CURACAVI" }, { "16165": "EL BOSQUE" }, { "14503": "EL MONTE" },
			{ "14157": "ESTACION CENTRAL" }, { "14158": "HUECHURABA" }, { "13167": "INDEPENDENCIA" }, { "14502": "ISLA DE MAIPO" },
			{ "16110": "LA CISTERNA" }, { "15128": "LA FLORIDA" }, { "16131": "LA GRANJA" }, { "16154": "LA PINTANA" }, { "15132": "LA REINA" },
			{ "14202": "LAMPA" }, { "15108": "LAS CONDES" }, { "15161": "LO BARNECHEA" }, { "16164": "LO ESPEJO" }, { "14155": "LO PRADO" },
			{ "15151": "MACUL" }, { "14109": "MAIPU" }, { "14602": "MARIA PINTO" }, { "14601": "MELIPILLA" }, { "15105": "NUNOA" },
			{ "14505": "PADRE HURTADO" }, { "16404": "PAINE" }, { "16162": "PEDRO AGUIRRE CERDA" }, { "14504": "PENAFLOR" }, { "15152": "PENALOLEN" },
			{ "16302": "PIRQUE" }, { "15103": "PROVIDENCIA" }, { "14111": "PUDAHUEL" }, { "16301": "PUENTE ALTO" }, { "14114": "QUILICURA" },
			{ "14107": "QUINTA NORMAL" }, { "13159": "RECOLETA" }, { "14113": "RENCA" }, { "16401": "SAN BERNARDO" }, { "16163": "SAN JOAQUIN" },
			{ "16303": "SAN JOSE MAIPO" }, { "16106": "SAN MIGUEL" }, { "14604": "SAN PEDRO" }, { "16153": "SAN RAMON" }, { "13101": "SANTIAGO" },
			{ "13134": "SANTIAGO OESTE" }, { "13135": "SANTIAGO SUR" }, { "14501": "TALAGANTE" }, { "14203": "TIL TIL" }, { "15160": "VITACURA" }
		]
	},
	"06": {
		name: "REGION DEL LIBERTADOR BERNARDO O'HIGGINS",
		cities: [
			{ "06209": "CHEPICA" }, { "06202": "CHIMBARONGO" }, { "06107": "CODEGUA" }, { "06116": "COINCO" }, { "06106": "COLTAUCO" }, { "06105": "DONIHUE" },
			{ "06103": "GRANEROS" }, { "06304": "LA ESTRELLA" }, { "06109": "LAS CABRAS" }, { "06303": "LITUECHE" }, { "06206": "LOLOL" },
			{ "06102": "MACHALI" }, { "06115": "MALLOA" }, { "06305": "MARCHIGUE" }, { "06203": "NANCAGUA" }, { "06302": "NAVIDAD" },
			{ "06114": "OLIVAR" }, { "06207": "PALMILLA" }, { "06306": "PAREDONES" }, { "06208": "PERALILLO" }, { "06108": "PEUMO" },
			{ "06111": "PICHIDEGUA" }, { "06301": "PICHILEMU" }, { "06204": "PLACILLA" }, { "06214": "PUMANQUE" }, { "06117": "QUINTA DE TILCOCO" },
			{ "06101": "RANCAGUA" }, { "06112": "RENGO" }, { "06113": "REQUINOA" }, { "06201": "SAN FERNANDO" }, { "06110": "SAN VICENTE" },
			{ "06205": "SANTA CRUZ" }, { "06104": "SN. FCO. DE MOSTAZAL" }
		]
	},
	"07": { 
		name: "REGION DEL MAULE", 
		cities: [
			{ "07401": "CAUQUENES" }, { "07403": "CHANCO" }, { "07303": "COLBUN" }, { "07208": "CONSTITUCION" }, { "07207": "CUREPTO" },
			{ "07101": "CURICO" }, { "07209": "EMPEDRADO" }, { "07107": "HUALANE" }, { "07105": "LICANTEN" }, { "07301": "LINARES" },
			{ "07304": "LONGAVI" }, { "07206": "MAULE" }, { "07108": "MOLINA" }, { "07305": "PARRAL" }, { "07203": "PELARCO" }, 
			{ "07402": "PELLUHUE" }, { "07205": "PENCAHUE" }, { "07104": "RAUCO" }, { "07306": "RETIRO" }, { "07204": "RIO CLARO" },
			{ "07103": "ROMERAL" }, { "07109": "SAGRADA FAMILIA" }, { "07202": "SAN CLEMENTE" }, { "07310": "SAN JAVIER" }, { "07210": "SAN RAFAEL" },
			{ "07201": "TALCA" }, { "07102": "TENO" }, { "07106": "VICHUQUEN" }, { "07309": "VILLA ALEGRE" }, { "07302": "YERBAS BUENAS" }
		] 
	},
	"16": { 
		name: "REGION DE ÑUBLE", 
		cities: [
			{ "08113": "BULNES" }, { "08101": "CHILLAN" }, { "08121": "CHILLAN VIEJO" }, { "08107": "COBQUECURA" }, { "08120": "COELEMU" },
			{ "08103": "COIHUECO" }, { "08118": "EL CARMEN" }, { "08105": "NINHUE" }, { "08110": "NIQUEN" }, { "08117": "PEMUCO" },
			{ "08102": "PINTO" }, { "08106": "PORTEZUELO" }, { "08115": "QUILLON" }, { "08104": "QUIRIHUE" }, { "08119": "RANQUIL" }, { "08109": "SAN CARLOS" },
			{ "08111": "SAN FABIAN" }, { "08114": "SAN IGNACIO" }, { "08112": "SAN NICOLAS" }, { "08108": "TREHUACO" }, { "08116": "YUNGAY" }
		]
	},
	"08": { 
		name: "REGION DEL BIO BIO", 
		cities: [
			{ "08414": "ALTO BIOBIO" }, { "08413": "ANTUCO" }, { "08301": "ARAUCO" }, { "08410": "CABRERO" }, { "08305": "CANETE" }, { "08211": "CHIGUAYANTE" },
			{ "08201": "CONCEPCION" }, { "08306": "CONTULMO" }, { "08207": "CORONEL" }, { "08302": "CURANILAHUE" }, { "08204": "FLORIDA" },
			{ "08212": "HUALPEN" }, { "08203": "HUALQUI" }, { "08403": "LAJA" }, { "08303": "LEBU" }, { "08304": "LOS ALAMOS" }, { "08401": "LOS ANGELES" },
			{ "08208": "LOTA" }, { "08407": "MULCHEN" }, { "08405": "NACIMIENTO" }, { "08406": "NEGRETE" }, { "08202": "PENCO" }, { "08408": "QUILACO" },
			{ "08404": "QUILLECO" }, { "08210": "SAN PEDRO DE LA PAZ" }, { "08411": "SAN ROSENDO" }, { "08402": "SANTA BARBARA" }, { "08209": "SANTA JUANA" },
			{ "08206": "TALCAHUANO" }, { "08307": "TIRUA" }, { "08205": "TOME" }, { "08412": "TUCAPEL" }, { "08409": "YUMBEL" }
		] 
	},
	"09": { 
		name: "REGION DE LA ARAUCANIA", 
		cities: [
			{ "09101": "ANGOL" }, { "09209": "CARAHUE" }, { "09221": "CHOLCHOL" }, { "09105": "COLLIPULLI" }, { "09204": "CUNCO" }, { "09110": "CURACAUTIN" },
			{ "09218": "CURARREHUE" }, { "09106": "ERCILLA" }, { "09203": "FREIRE" }, { "09207": "GALVARINO" }, { "09212": "GORBEA" }, { "09205": "LAUTARO" },
			{ "09214": "LONCOCHE" }, { "09111": "LONQUIMAY" }, { "09103": "LOS SAUCES" }, { "09108": "LUMACO" }, { "09217": "MELIPEUCO" }, { "09208": "NUEVA IMPERIAL" },
			{ "09220": "PADRE LAS CASAS" }, { "09206": "PERQUENCO" }, { "09211": "PITRUFQUEN" }, { "09216": "PUCON" }, { "09102": "PUREN" },
			{ "09104": "RENAICO" }, { "09210": "SAAVEDRA" }, { "09201": "TEMUCO" }, { "09219": "TEODORO SCHMIDT" }, { "09213": "TOLTEN" }, { "09107": "TRAIGUEN" },
			{ "09109": "VICTORIA" }, { "09202": "VILCUN" }, { "09215": "VILLARRICA" }
		] 
	},
	"14": { 
		name: "REGION DE LOS RIOS", 
		cities: [
			{ "10106": "CORRAL" }, { "10105": "FUTRONO" }, { "10109": "LA UNION" }, { "10112": "LAGO RANCO" }, { "10103": "LANCO" }, { "10104": "LOS LAGOS" },
			{ "10107": "MAFIL" }, { "10102": "MARIQUINA" }, { "10110": "PAILLACO" }, { "10108": "PANGUIPULLI" }, { "10111": "RIO BUENO" }, { "10101": "VALDIVIA" }
		]
	},
	"10": { 
		name: "REGION DE LOS LAGOS", 
		cities: [
			{ "10406": "ANCUD" }, { "10309": "CALBUCO" }, { "10401": "CASTRO" }, { "10501": "CHAITEN" }, { "10402": "CHONCHI" }, 
			{ "10302": "COCHAMO" }, { "10410": "CURACO DE VELEZ" }, { "10408": "DALCAHUE" }, { "10304": "FRESIA" }, { "10305": "FRUTILLAR" },
			{ "10503": "FUTALEUFU" }, { "10502": "HUALAIHUE" }, { "10306": "LLANQUIHUE" }, { "10308": "LOS MUERMOS" }, { "10307": "MAULLIN" },
			{ "10201": "OSORNO" }, { "10504": "PALENA" }, { "10301": "PUERTO MONTT" }, { "10203": "PUERTO OCTAY" }, { "10303": "PUERTO VARAS" },
			{ "10405": "PUQUELDON" }, {"10206": "PURRANQUE" }, { "10204": "PUYEHUE" }, { "10403": "QUEILEN" }, { "10404": "QUELLON" },
			{ "10407": "QUEMCHI" }, { "10415": "QUINCHAO" }, { "10205": "RIO NEGRO" }, { "10207": "SAN JUAN DE LA COSTA" }, {"10202": "SAN PABLO"}
		] 
	},
	"11": { 
		name: "REGION DE AYSEN DEL GENERAL CARLOS IBAÑEZ DEL CAMPO", 
		cities: [
			{ "11101": "AYSEN" }, { "11201": "CHILE CHICO" }, { "11102": "CISNES" }, { "11301": "COCHRANE" }, { "11401": "COYHAIQUE" },
			{ "11104": "GUAITECAS" }, { "11402": "LAGO VERDE" }, { "11302": "OHIGGINS" }, { "11203": "RIO IBANEZ" }, { "11303": "TORTEL" }
		] 
	},
	"12": { 
		name: "REGION DE MAGALLANES Y LA ANTARTICA CHILENA", 
		cities: [
			{ "12401": "CABO DE HORNOS" }, { "12206": "LAGUNA BLANCA" }, { "12101": "NATALES" }, { "12301": "PORVENIR" },
			{ "12302": "PRIMAVERA" }, { "12205": "PUNTA ARENAS" }, { "12202": "RIO VERDE" }, { "12204": "SAN GREGORIO" },
			{ "12304": "TIMAUKEL" }, { "12103": "TORRES DEL PAINE" }
		] 
	}
};

export const COURTS = {

	"C.A. de Arica" : 10,
	"C.A. de Iquique" : 11,
	"C.A. de Antofagasta" : 15,
	"C.A. de Copiapó" : 20,
	"C.A. de La Serena" : 25,
	"C.A. de Valparaíso" : 30
};

export const Magistrates = {

	10: { // Arica
		"1º Juzgado de Letras de Arica" : 2,
		"2º Juzgado de Letras de Arica" : 3,
		"1º Juzgado De Letras de Arica ex 4°" : 1400,
		"2º Juzgado De Letras de Arica ex 4°" : 1401,
		"3º Juzgado de Letras de Arica Ex 4º" : 5,
		"3º Juzgado de Letras de Arica" : 4
	},
	11: { // Iquique
		"Juzgado de Letras y Gar. Pozo Almonte" : 6,
		"1º Juzgado de Letras de Iquique" : 9,
		"2º Juzgado de Letras de Iquique" : 10,
		"3º Juzgado de Letras de Iquique" : 11
	},
	15: { // Antofagasta
		"Juzgado de Letras Tocopilla" : 13,
		"Juzgado de Letras y Gar.de María Elena" : 14,
		"1º Juzgado de Letras de Calama" : 16,
		"2º Juzgado de Letras de Calama" : 17,
		"3º Juzgado de Letras de Calama ": 658,
		"Juzgado de Letras y Gar. de Taltal" : 26,
		"1º Juzgado de Letras Civil de Antofagasta" : 1041,
		"2º Juzgado de Letras Civil de Antofagasta" : 1042,
		"3º Juzgado de Letras Civil de Antofagasta" : 1043,
		"4º Juzgado de Letras Civil de Antofagasta" : 1044,
		"Juzgado de Letras y Garantía Mejillones" : 1501
	},
	20: { // Copiapó
		"Juzgado de Letras y Gar. de Chañaral" : 27,
		"Juzgado de Letras de Diego de Almagro" : 29,
		"1º Juzgado de Letras de Copiapó" : 31,
		"2º Juzgado de Letras de Copiapó" : 32,
		"3º Juzgado de Letras de Copiapó" : 33,
		"Juzgado de Letras y Gar.de Freirina" : 34,
		"4º Juzgado de Letras de Copiapó" : 926,
		"1º Juzgado de Letras de Vallenar" : 36,
		"2º Juzgado de Letras de Vallenar" : 37,
		"Juzgado de Letras y Gar.de Caldera" : 386
	},
	25: { //la serena
		"1º Juzgado de Letras de la Serena": 40,
		"2º Juzgado de Letras de la Serena": 41,
		"3º Juzgado de Letras de la Serena": 42,
		"1º Juzgado de Letras de Coquimbo": 43,
		"2º Juzgado de Letras de Coquimbo": 44,
		"3º Juzgado de Letras de Coquimbo": 45,
		"Juzgado de Letras de Vicuña": 46,
		"Juzgado de letras y garantía de Andacollo": 47,
		"1º Juzgado de Letras de Ovalle": 48,
		"2º Juzgado de Letras de Ovalle": 49,
		"3º Juzgado de Letras de Ovalle": 50,
		"Juzgado de Letras y Gar.de Combarbalá": 51,
		"Juzgado de Letras de Illapel": 52,
		"Juzgado de Letras y Gar. de los Vilos": 53
	}, 
	30: { //Valparaiso

		"1º Juzgado Civil de Valparaíso": 56,
		"2º Juzgado Civil de Valparaíso": 55,
		"3º Juzgado Civil de Valparaíso": 54,
		"4º Juzgado Civil de Valparaíso": 59,
		"5º Juzgado Civil de Valparaíso": 60,
		"1º Juzgado Civil de Viña del Mar": 57,
		"2º Juzgado Civil de Viña del Mar": 58,
		"3º Juzgado Civil de Viña del Mar": 61,
		"1º Juzgado de Letras de Quilpue": 83,
		"2º Juzgado de Letras de Quilpue": 84,
		"Juzgado de Letras de Villa Alemana": 85,
		"Juzgado de Letras de Casablanca": 86,
		"Juzgado de Letras de La Ligua": 87,
		"Juzgado de Letras y Gar. de Petorca": 88,
		"1º Juzgado de Letras de Los Andes": 89,
		"2º Juzgado de Letras de Los Andes": 90,
		"1º Juzgado de Letras de San Felipe": 92,
		"1º Juzgado de Letras de San Felipe Ex 2º": 93,
		"Juzgado de Letras y Gar.de Putaendo": 94,
		"1º Juzgado de Letras de Quillota": 96,
		"2º Juzgado de Letras de Quillota": 97,
		"Juzgado de Letras de La Calera": 98,
		"Juzgado de Letras de Limache": 99,
		"1º Juzgado de Letras de San Antonio": 101,
		"2º Juzgado de Letras de San Antonio": 102,
		"Juzgado de Letras y Gar. de Isla de Pascua": 103,
		"Juzgado de Letras y Gar.de Quintero": 660
	}
}

 export const toObject = (v) => {
	if (typeof v === 'string') {
		try { return JSON.parse(v); } 
		catch (e) { 
		console.error('JSON inválido:', v, e);
		return null;
		}
	}

	return v;
};